module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/ma-gallery/ma-gallery-08-fd599de1752f9c7dd2ae2e180c4e9bc3.jpg";